import { AuthedRoute } from "../../helpers/authed-route";
import {
  NamedRoute,
  route,
} from "../../../application/domain/routing/named-route";
import { Redirect } from "react-router-dom";
import { HelpTop } from "./top";
import { HelpProductTop } from "./product-top";
import { HelpContentDetail } from "./detail";

export const RedirectToHome: React.FC = () => {
  return <Redirect to={HelpR.HelpHome.link({})} />;
};

export const HelpR = {
  HelpHome: route({
    path: "/help",
    link: () => `/help`,
    component: HelpTop,
  }),
  HelpRedirectToHome: route({
    path: "/help/contents/home",
    link: () => `/help/contents/home`,
    component: RedirectToHome,
  }),
  HelpContent: route({
    path: "/help/contents/:objectSlug",
    link: (objectSlug: string) => `/help/contents/${objectSlug}`,
    component: HelpContentDetail,
  }),
  HelpServiceTop: route({
    path: "/help/:productId",
    link: (productId: string) => `/help/${productId}`,
    component: HelpProductTop,
  }),
};

export const HelpRoutes = () => {
  return (
    <>
      {Object.keys(HelpR).map((k: string) => {
        const r = (HelpR as { [key: string]: NamedRoute<any> })[k].forRouter;

        if (r.hidden) {
          return null;
        }

        return (
          <AuthedRoute
            exact
            path={r.path}
            component={r.component}
            key={`SettingsRoutes-${k}`}
          />
        );
      })}
    </>
  );
};
